module.exports = __webpack_public_path__ + "static/img/renmingyoudianchubanse.ad9d348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/renmingyoudianchubanse.png
// module id = OfKk
// module chunks = 46